'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDynamicAdContent = isDynamicAdContent;
exports.default = injectCompanionAd;

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _logger = require('../../../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _reporter = require('../../reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _injectDynamicAdContent = require('./injectDynamicAdContent');

var _injectDynamicAdContent2 = _interopRequireDefault(_injectDynamicAdContent);

var _injectStaticAdContent = require('./injectStaticAdContent');

var _injectStaticAdContent2 = _interopRequireDefault(_injectStaticAdContent);

var _constants = require('../../../logging/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A utility function to determine if ad content is dynamic. If the ad content
 * is a string, then checking for the existence of a script tag to determine if
 * it is dynamic or not.
 * @param content {string}
 * @returns {boolean}
 */
function isDynamicAdContent(content) {
  if (!content || !(0, _isString2.default)(content)) {
    return false;
  }
  var scriptTagIndex = content.indexOf('<script>');

  return scriptTagIndex >= 0;
}

function injectCompanionAd(options) {
  var adSlot = options.adSlot,
      adContent = options.adContent,
      adContainer = options.adContainer,
      adWidth = options.adWidth,
      adHeight = options.adHeight;


  function reportClick() {
    _reporter2.default.click(adSlot);
    _logger2.default.info({
      message: _constants.COMPANION_AD_CLICKED,
      data: _reporter2.default.getParameters(adSlot)
    });
  }

  function reportError() {
    _logger2.default.error({
      message: _constants.COMPANION_INVALID_CLICK_HANDLER,
      data: _reporter2.default.getParameters(adSlot)
    });
  }

  try {
    var element = isDynamicAdContent(adContent) ? (0, _injectDynamicAdContent2.default)(adContainer, adContent, adWidth, adHeight) : (0, _injectStaticAdContent2.default)(adContainer, adContent);

    if (!element) {
      reportError();
      return;
    }

    element.addEventListener('click', reportClick);
  } catch (ex) {
    _logger2.default.error({
      message: _constants.COMPANION_AD_RENDER_ERROR,
      error: ex,
      data: _reporter2.default.getParameters(adSlot)
    });
  }
}